export default __webpack_public_path__ + "static/media/T&C.a7d33a27.docx";